export default class InvaderGame {
  constructor() {
    this.hero = document.querySelector('[data-invaders]');

    if (!this.hero) {
      return;
    }

    this.timers = new Set();
    this.onClick = this.onClick.bind(this);
    this.fit = this.fit.bind(this);

    this.fit();
    window.addEventListener('resize', this.fit);

    document.addEventListener('click', this.onClick, true);
  }

  fit() {
    this.hero.querySelectorAll('.invader').forEach((invader) => {
      const size = parseFloat(invader.dataset.size);
      let scale = parseFloat(invader.style.getPropertyValue('--scale')) || 1;

      if (size) {
        scale = this.hero.clientWidth * size / 100 / 33;
        invader.style.setProperty('--scale', scale.toFixed(2));
      }

      const top = parseFloat(invader.style.getPropertyValue('--top')) || 0;

      invader.style.zIndex = 3 + Math.round(top * 1000 + scale * 10);
    });
  }

  later(fn, ms) {
    const id = setTimeout(() => {
      this.timers.delete(id);
      fn();
    }, ms);

    this.timers.add(id);
  }

  onClick(e) {
    const invader = e.target.closest?.('.invader');

    if (!invader || invader.classList.contains('is-hit')) {
      return;
    }

    const heroRect = this.hero.getBoundingClientRect();
    const rect = invader.getBoundingClientRect();
    const x = rect.left + rect.width / 2 - heroRect.left;
    const y = rect.top + rect.height / 2 - heroRect.top;

    const beam = document.createElement('div');
    beam.className = 'laser';
    beam.style.cssText = `left:${x - 1}px;top:${y}px;height:${heroRect.height - y}px;color:${getComputedStyle(invader).getPropertyValue('--color')}`;
    this.hero.appendChild(beam);
    this.later(() => beam.remove(), 220);

    invader.classList.add('is-hit');
    this.crumble(invader);

    this.later(() => {
      invader.classList.remove('is-hit');
      invader.style.animation = 'none';
      void invader.offsetWidth;
      invader.style.animation = '';
    }, 1700);
  }

  crumble(invader) {
    const sprite = invader.querySelector('.invader__sprite');
    const shadows = getComputedStyle(sprite).boxShadow.split(/,\s*(?=rgb)/);

    shadows.forEach((shadow) => {
      const [x, y] = shadow.match(/-?\d+(?:\.\d+)?px/g) || [];

      if (x === undefined) {
        return;
      }

      const pixel = document.createElement('span');

      pixel.className = 'invader__pixel';
      pixel.style.left = `${sprite.offsetLeft + parseFloat(x)}px`;
      pixel.style.top = `${sprite.offsetTop + parseFloat(y)}px`;
      invader.appendChild(pixel);

      pixel.animate(
        [
          { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
          {
            transform: `translate(${(Math.random() - 0.5) * 30}px, ${25 + Math.random() * 45}px) rotate(${(Math.random() - 0.5) * 360}deg)`,
            opacity: 0,
          },
        ],
        {
          duration: 500 + Math.random() * 500,
          delay: 100 + Math.random() * 200,
          easing: 'ease-in',
          fill: 'forwards',
        },
      ).onfinish = () => pixel.remove();
    });
  }

  destroy() {
    if (!this.timers) {
      return;
    }

    document.removeEventListener('click', this.onClick, true);
    window.removeEventListener('resize', this.fit);
    this.timers.forEach(clearTimeout);
    this.hero.querySelectorAll('.laser, .invader__pixel').forEach((el) => el.remove());
  }
}
